import React from 'react';
import classNames from 'classnames';
import './LassoAdorner.less';
import { IPoint } from 'utils/GeometryUtils';

export interface ILassoAdornerProps extends React.HTMLProps<HTMLDivElement> {
  startPoint: IPoint;
  endPoint: IPoint;
  /**
   * @default 0
   */
  zIndex?: number;
}

const getClassName = (className?: string) => classNames('dpc-lasso-adorner', className);

/**
 * Draws a selection area and uses for multi-selection.
 * Supposed to be used with "useDragAndDrop" hook.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const LassoAdorner = React.memo(
  ({ startPoint, endPoint, className, zIndex, ...otherProps }: ILassoAdornerProps) => {
    const width = Math.abs((endPoint.x ?? 0) - (startPoint.x ?? 0));
    const height = Math.abs((endPoint.y ?? 0) - (startPoint.y ?? 0));
    const left = Math.min(startPoint.x, endPoint.x);
    const top = Math.min(startPoint.y, endPoint.y);

    return <div className={getClassName(className)} style={{ width, height, left, top, zIndex }} {...otherProps}></div>;
  }
);
